import React from 'react'
import { Box, Button } from '@chakra-ui/react'
import { FaVideo } from 'react-icons/fa'

import FileChooser from '../includes/FileChooser'
import PrivateVideo from '../includes/PrivateVideo'

export default function Video ({ dataType, value, onChange, participant }) {
  return (
    <Box>
      {!value?.fileName &&
        <FileChooser
          accept='video/*,.mp4,.mkv,.avi,.mov'
          forType='participant' forObject={participant}
          onComplete={({ storedName, name }) => onChange({ name, fileName: storedName, needsVideoProcess: true })}
          trigger={<Button size='sm' variant='outline' colorScheme='primary'><Box as={FaVideo} mr={2} /> Choose a file</Button>}
        />}
      {value?.fileName &&
        <PrivateVideo forType='participant' forObject={participant} name={value.fileName} onRemove={() => onChange('')} isProcessing={value.needsVideoProcess} hasError={value.processError} />}
    </Box>
  )
}
